<template>
  <footer class="main-footer">
    <div class="pull-right hidden-xs">
      <b>Version</b> 2.4.3
    </div>
    <strong>Mister Aladin &copy; {{ currentYear }}.</strong> All rights reserved.
  </footer>
</template>

<script>
  export default {
    name: 'DashboardFooter',

    data() {
      return {
        currentYear: (new Date()).getFullYear(),
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/partials/Footer.vue